module.exports = "https://coinrabbit.io/_next/static/images/reddit-vip-3e06b3f0a64fc6071f51a7dbccbb5ea1.svg";